export default "/images/8b6f98230f5d219f7278914195f59c26.avif";